module.exports = __webpack_public_path__ + "img/icon-social-group-24-px.c9297208.svg";